{
  "name": "wandify",
  "version": "1.69.0",
  "scripts": {
    "ng": "ng",
    "generate-build-info": "node scripts/generate-build-info.js",
    "postinstall": "node scripts/generate-build-info.js",
    "prebuild": "node scripts/generate-build-info.js",
    "prestart": "node scripts/generate-build-info.js",
    "prebuild-test3": "node scripts/generate-build-info.js",
    "prebuild-test4": "node scripts/generate-build-info.js",
    "prestage": "node scripts/generate-build-info.js",
    "preprod": "node scripts/generate-build-info.js",
    "start": "ng serve",
    "build": "ng build",
    "build-test3": "ng build --configuration test3",
    "build-test4": "ng build --configuration test4",
    "stage": "ng build --configuration stage --output-hashing=all",
    "prod": "ng build --configuration production --output-hashing=all",
    "test-compressed": "npm run build && npx gzipper compress ./dist/wandify",
    "test3-compressed": "npm run build-test3 && npx gzipper compress ./dist/wandify",
    "test4-compressed": "npm run build-test4 && npx gzipper compress ./dist/wandify",
    "stage-compressed": "npm run stage && npx gzipper compress ./dist/wandify",
    "prod-compressed": "npm run prod && npx gzipper compress ./dist/wandify",
    "lint": "ng lint"
  },
  "private": true,
  "engines": {
    "node": "^20.11.1 || ^22.0.0"
  },
  "dependencies": {
    "@angular-slider/ngx-slider": "^19.0.0",
    "@angular/animations": "^19.2.25",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "^19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/elements": "^19.2.25",
    "@angular/forms": "^19.2.25",
    "@angular/material": "^19.2.19",
    "@angular/material-date-fns-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@angular/service-worker": "^19.2.25",
    "@auth0/angular-jwt": "^5.0.1",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-brands-svg-icons": "^6.7.2",
    "@fortawesome/free-regular-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@stripe/stripe-js": "^2.1.7",
    "date-fns": "^2.30.0",
    "date-fns-tz": "^2.0.1",
    "emoji-picker-element": "^1.21.3",
    "google-libphonenumber": "^3.2.40",
    "jspdf": "^2.5.1",
    "ngx-image-cropper": "^9.1.6",
    "normalize.css": "^8.0.1",
    "quill": "^2.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.27",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.2.25",
    "@softarc/eslint-plugin-sheriff": "^0.19.6",
    "@softarc/sheriff-core": "^0.19.6",
    "@types/eslint": "^8.40.1",
    "@types/estree": "^1.0.1",
    "@types/node": "^20.19.43",
    "@typescript-eslint/eslint-plugin": "^8.59.2",
    "@typescript-eslint/parser": "^8.59.2",
    "@typescript-eslint/utils": "^8.59.2",
    "eslint": "^8.0.0",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-prettier": "^5.5.5",
    "gzipper": "^4.0.2",
    "prettier": "3.8.1",
    "ts-node": "~8.3.0",
    "typescript": "~5.8.3"
  },
  "browser": {
    "child_process": false
  }
}
